import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { LabsPage } from './LabsPage'
import { NutritionPage } from './NutritionPage'
import { PressurePage } from './PressurePage'
import { SupplementsPage } from './SupplementsPage'
import { WellbeingPage } from './WellbeingPage'

export const routes: RouteObject[] = [
  { path: '/health/pressure', element: <PressurePage /> },
  { path: '/health/wellbeing', element: <WellbeingPage /> },
  { path: '/health/labs', element: <LabsPage /> },
  { path: '/health/supplements', element: <SupplementsPage /> },
  { path: '/health/nutrition', element: <NutritionPage /> },
]

// Сам раздел «Здоровье» объявляет другой модуль (pages/health); здесь только его вкладки.
const tab = (path: string, label: string, icon: NavItem['icon'], order: number): NavItem => ({
  path,
  label,
  icon,
  mobile: null,
  order,
  parent: '/health',
})

export const nav: NavItem[] = [
  tab('/health/pressure', 'Давление', 'activity', 30),
  tab('/health/wellbeing', 'Самочувствие', 'user', 40),
  tab('/health/labs', 'Анализы', 'list', 50),
  tab('/health/supplements', 'Добавки', 'check', 60),
  tab('/health/nutrition', 'Питание', 'chart', 70),
]
